// Corner radii from the HTML design tokens. Softer than catalog: inputs/buttons
// 7px, cards 10px, drawers/modals 12–14px, chips/pills 20px, circles 999.
export const Radii = {
  r1:   6,   // small controls / mark boxes
  r2:   7,   // inputs, buttons
  r3:   10,  // cards
  r4:   12,  // drawers / modals
  r5:   14,  // large modals
  pill: 20,  // chips, pills, switch tracks
  full: 999, // avatars, dots, toggle knobs
};
